import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
    DEFAULT_THEME,
    DEFAULT_KIND,
    DEFAULT_SIZE,
    KINDS,
    PARENT_TYPES,
    PRIORITIES,
    SIZES,
    THEMES,
} from './configs/config';

export const Text = ({
    Tag,
    children,
    className,
    configs: { fontSize, lineHeight },
    inline,
    keepStyles,
    kind,
    lines,
    marginBottom,
    marginTop,
    parentType,
    priority,
    size,
    styles,
    theme,
    ...rest
}) => {
    const selectedFontSize = fontSize[kind][size];
    const selectedLineHeight = lineHeight[kind][size];

    const height = lines ? `calc(${lines} * ${selectedLineHeight} * ${selectedFontSize}px)` : null;

    const tagByPriority = priority ? `h${priority}` : 'p';
    const TagName = Tag ?? (inline ? 'span' : tagByPriority);

    const classNames = cn(
        styles.main,
        {
            [styles[`${kind}-margin-top-${size}`]]: marginTop && !inline,
            [styles[`${kind}-margin-bottom-${size}`]]: marginBottom && !inline,
            [styles[`${kind}-margin-bottom-parent-${parentType}-${size}`]]:
                !inline && marginBottom && kind === 'subtitle' && parentType,
            [styles[`${kind}-line-height-${size}`]]: !inline,
            [styles[`${kind}-font-size-${size}`]]: !inline || (inline && keepStyles),
        },
        styles[`${kind}-theme-${theme}`],
        className
    );

    return (
        <TagName className={classNames} style={{ height }} {...rest}>
            {children}
        </TagName>
    );
};

Text.propTypes = {
    /** Содержимое */
    children: PropTypes.node.isRequired,
    /** Внешние стили для переопределения */
    className: PropTypes.string,
    /** JS-размены шрифтов */
    configs: PropTypes.objectOf(PropTypes.object),
    /** Меняет HTML-представление на <span> */
    inline: PropTypes.bool,
    /**
     * При использовании 'inline=true', компонент наследует большую часть стилей от родителя.
     * Чтобы сохранить стили, используй 'keepStyles=true'
     */
    keepStyles: PropTypes.bool,
    /** Визуальный стиль текстового элемента */
    kind: PropTypes.oneOf(KINDS),
    /** При 'lines=(INT)' элемент сразу занимает на экране фиксированное число строк, независимо от контента */
    lines: PropTypes.number,
    /** 'marginBottom=false' выключает нижний отступ */
    marginBottom: PropTypes.bool,
    /** 'marginTop=false' выключает верхний отступ */
    marginTop: PropTypes.bool,
    /** Иногда нужно указать родителя, чтобы получить правильный отступ снизу */
    parentType: PropTypes.oneOf(PARENT_TYPES),
    /** Меняет HTML-представление элемента на <h1...5> */
    priority: PropTypes.oneOf(PRIORITIES),
    /** Визуальный размер элемента */
    size: PropTypes.oneOf(SIZES),
    /** CSS-стили компонента */
    styles: PropTypes.objectOf(PropTypes.string),
    /** Визуальная тема элемента (цвет) */
    theme: PropTypes.oneOf(THEMES),
};

Text.defaultProps = {
    className: '',
    configs: {},
    inline: false,
    keepStyles: false,
    kind: DEFAULT_KIND,
    lines: 0,
    marginBottom: true,
    marginTop: true,
    parentType: null,
    priority: 0,
    size: DEFAULT_SIZE,
    styles: {},
    theme: DEFAULT_THEME,
};
